import { Breakpoints, css, styled } from '@vw-marketing/us-components';

import { NavigationContainer } from '../Guide/styles';

export const ModelCardContainer: any = styled.div`
  ${({ theme, carImage }) => {
    return css`
      background: linear-gradient(${theme.colors.tab.stepnav.selected} 0%, ${theme.colors.tab.stepnav.selected} 100%) top / 100% 100% no-repeat;
      border-radius: 12px;
      height: 232px;

      padding-top: ${theme.size.static510};
      padding-bottom: ${carImage ? 0 : theme.size.static450};

      margin-bottom: 80px;

      @media (min-width: ${Breakpoints.b560}px) {
        padding-top: ${theme.size.static510};
        margin-bottom: 100px;
      }

      @media (min-width: ${Breakpoints.b1280}px) {
      }
    `;
  }}
`;

export const ModelCardContent: any = styled(NavigationContainer)`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;

export const ModelCardInfoSection: any = styled.div`
  flex-direction: column;
  width: 100%;
`;

export const TrimInfoContainer: any = styled.div`
  p {
    color: #3c484d;
  }
`;

export const ChangeVehicleCTAContainer: any = styled.div``;

export const ModelCardImageContainer: any = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: ${({ theme }) => theme.size.static150};

  @media (min-width: ${Breakpoints.b560}px) {
    justify-content: flex-end;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    justify-content: center;
  }

  img {
    min-width: 220px;
    width: 100%;
    margin-top: -45px;

    @media (min-width: ${Breakpoints.b560}px) {
      width: 376px;
    }
  }
`;
